module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Call-9ed7e70ebf607fb5d393f5fa5b5c643d.svg";